import React from "react";
import Prev from "../../images/prev.png";
import Next from "../../images/next.png";
import './Review.css'

const Review = () => {
  return (
    <>
      <div className="review-cnt">
        <div className="review-heading-wrapper">
          <h1 className="review-heading">What Our Clients Says</h1>
        </div>
        <div className="slider-wrapper">
          <div className="slider-prev-btn">
            <img src={Prev} alt="" />
          </div>
          <div className="slider-cnt">
            <p className="text">
              psum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et doloremagnaaliqua. Ut enim ad minim
              veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
              ex eacommodoconsequat. Duis aute irure dolor in reprehenderit in
              voluptate velit esse cillum
            </p>
          </div>
          <div className="slider-prev-btn">
            <img src={Next} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Review;
